import React, { CSSProperties } from "react";
import { BeatLoader } from "react-spinners";

type Props = {};
const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

export default function Spinner({}: Props) {
  return (
    <div className="spinner-background">
      <BeatLoader loading={true} color="#0035A8" size={12} className="spinner" />
    </div>
  );
}
